/** Map user profile withdrawal preset ↔ wallet withdrawal form fields. */

export function withdrawalPresetFromUser(user) {
  if (!user) {
    return {
      bank_account_name: "",
      bank_account_number: "",
      bank_name: "",
      routing_number: "",
    };
  }
  return {
    bank_account_name: String(user.withdrawal_preset_account_name ?? "").trim(),
    bank_account_number: String(user.withdrawal_preset_account_number ?? "").trim(),
    bank_name: String(user.withdrawal_preset_bank_name ?? "").trim(),
    routing_number: String(user.withdrawal_preset_routing_number ?? "").trim(),
  };
}

export function userPatchFromWithdrawalPreset(form) {
  return {
    withdrawal_preset_account_name: String(form.bank_account_name ?? "").trim(),
    withdrawal_preset_account_number: String(form.bank_account_number ?? "").trim(),
    withdrawal_preset_bank_name: String(form.bank_name ?? "").trim(),
    withdrawal_preset_routing_number: String(form.routing_number ?? "").trim(),
  };
}

export function hasWithdrawalPreset(user) {
  const p = withdrawalPresetFromUser(user);
  return Boolean(p.bank_account_name && p.bank_account_number && p.bank_name);
}
